<div class="!py-5 admin-custom">
    <!-- create form comment -->
    <div class="flex !gap-3 !mb-3">
        <img class="!w-10 !h-10 rounded-full" [src]="getImageUrl(avatarMyself)" (error)="replaceWithDefaultAvatar($event)" />
        <div class="flex-1 border border-palette-gray-300 rounded-lg custom-textarea focus-within:!border-palette-blue-300">
            <textarea
                #boxCreate
                pInputTextarea
                [autoResize]="1"
                [(ngModel)]="content"
                (keydown)="handleKeydownCreate($event)"
                class="w-full !p-3 text-sm resize-none textarea-comment max-h-[400px] rounded-t-lg"
                placeholder="{{ 'COMMENTS.ADD_A_COMMENT' | translate }}">
            </textarea>
    
            <div class="flex items-center justify-between !p-1.5 !pt-0">
                <input
                    #fileCreate
                    type="file"
                    [accept]="accept"
                    (change)="onSelect($event, 'create')"
                    hidden
                />
                <button class="!p-1.5 !w-7 !h-7 flex items-center hover:bg-palette-gray-200 rounded-md" type="button" (click)="fileCreate.click()">
                    <i class="sctr-icon-image-01 text-base text-palette-gray-900"></i>
                </button>
                <button [disabled]="!canCreate" [ngClass]="{ 'hover:cursor-not-allowed': !canCreate}" class=" !p-1.5 !w-7 !h-7 flex items-center hover:bg-palette-gray-200 rounded-md" type="button" (click)="create()">
                    <ng-container *ngIf="!loading">
                        <i 
                            class="sctr-icon-solid-send-03 text-base text-palette-gray-300"
                            [ngClass]="{ '!text-palette-blue-600': canCreate}">
                        </i>
                    </ng-container>
                    <ng-container *ngIf="loading">
                        <app-loading [style]="'!w-4 !h-4'"></app-loading>
                    </ng-container>
                </button>
            </div>
    
            <!-- preview create -->
            <ng-container *ngIf="uploaded.length">
                <div class="!p-3 !pt-0">
                    <ng-container *ngIf="isImg(uploaded[0]); else vidCreate">
                        <div class="relative !w-24 !h-24 rounded-lg hover:cursor-pointer">
                            <img
                                (click)="fileCreate.click()"
                                [src]="uploaded[0].url"
                                (error)="replaceWithDefaultImage($event)"
                                class="!w-24 !h-24 object-cover rounded-lg"
                            />
                            <button
                                (click)="removeFile('create')"
                                class="absolute top-[5px] right-[5px] !w-5 !h-5 bg-palette-gray-400 rounded-full flex items-center justify-center">
                                <i class="sctr-icon-x-close text-sm"></i>
                            </button>
                        </div>
                    </ng-container>
                    <ng-template #vidCreate>
                        <div class="relative !w-24 !h-24 rounded-lg hover:cursor-pointer">
                            <video
                                (click)="fileCreate.click()"
                                [src]="uploaded[0].url"
                                controls
                                class="!w-24 !h-24 rounded-lg"
                            ></video>
                            <button
                                (click)="removeFile('create')"
                                class="absolute top-[5px] right-[5px] !w-5 !h-5 bg-palette-gray-400 rounded-full flex items-center justify-center">
                                <i class="sctr-icon-x-close text-sm"></i>
                            </button>
                        </div>
                    </ng-template>
                </div>
            </ng-container>
        </div>
    </div>
  
    <!-- list comment -->
    <div
        class="max-h-[520px] overflow-y-auto pr-2 activity-scroll"
        (scroll)="onScroll($event)"
    >
        <div [attr.id]="'comment-' + c.id" *ngFor="let c of comments; index as i" class="flex !gap-3 !mb-3">
            <img
                class="!w-10 !h-10 rounded-full"
                [src]="getImageUrl(c.created_by.avatar_thumbnail_url)"
                (error)="replaceWithDefaultAvatar($event)"
            />
        
            <div class="flex-1 rounded-lg custom-textarea focus-within:!border-palette-blue-300" [ngClass]="{ 'border border-palette-gray-300': editingId === c.id }">
                <!-- EDIT MODE -->
                <ng-container *ngIf="editingId === c.id; else readMode">
                    <textarea
                        #boxEdit
                        pInputTextarea
                        [autoResize]="1"
                        (keydown)="handleKeydownEdit($event)"
                        [(ngModel)]="editContent"
                        class="w-full !p-3 text-sm resize-none textarea-comment max-h-[400px] rounded-t-lg">
                    </textarea>

                    <div class="flex items-center justify-between !p-1.5 !pt-0">
                        <input
                            #fileEdit
                            type="file"
                            [accept]="accept"
                            (change)="onSelect($event, 'edit')"
                            hidden
                        />
                        <button class="!p-1.5 !w-7 !h-7 flex items-center hover:bg-palette-gray-200 rounded-md" type="button" (click)="fileEdit.click()">
                            <i class="sctr-icon-image-01 text-base text-palette-gray-900"></i>
                        </button>
                        <div class="flex !gap-2">
                            <button 
                                [disabled]="loadingEdit"
                                [ngClass]="{ 'hover:cursor-not-allowed !opacity-50': loadingEdit}"
                                class="!py-1 !px-2 !h-7 border border-palette-gray-300 flex items-center
                                        bg-white rounded-lg font-inter !font-semibold text-palette-gray-900" (click)="cancelEdit()">
                                {{ 'COMMON.CANCEL' | translate }}
                            </button>
                            <button 
                                [disabled]="!canSaveEdit" [ngClass]="{ 'hover:cursor-not-allowed !opacity-50': !canSaveEdit}"
                                class="!py-1 !px-2 !h-7 border border-palette-blue-600 bg-palette-blue-600 flex items-center
                                        rounded-lg font-inter !font-semibold text-palette-base-white" type="button" (click)="saveEdit()">
                                <ng-container *ngIf="!loadingEdit">
                                    {{ 'COMMON.SAVE' | translate }}
                                </ng-container>
                                <ng-container *ngIf="loadingEdit">
                                    <app-loading [style]="'!w-4 !h-4'"></app-loading>
                                    {{ 'COMMON.SAVE' | translate }}
                                </ng-container>
                            </button>
                        </div>
                    </div>
            
                    <div *ngIf="editFiles.length || editMediasBackup.length" class="!mt-2 relative w-[100px] aspect-square !p-3 !pt-0">
                        <!-- 1. NEW file -->
                        <ng-container *ngIf="editFiles.length; else oldMedia">
                            <ng-container *ngIf="isImg(editFiles[0]); else vidNew">
                                <div class="relative !w-24 !h-24 rounded-lg hover:cursor-pointer">
                                    <img [src]="getMediaSrc(editFiles[0])" (click)="fileEdit.click()" (error)="replaceWithDefaultImage($event)" class="w-full h-full object-cover rounded-lg" />
                                    <button
                                        (click)="removeFile('edit')"
                                        class="absolute top-[5px] right-[5px] !w-5 !h-5 bg-palette-gray-400 rounded-full flex items-center justify-center">
                                        <i class="sctr-icon-x-close text-sm"></i>
                                    </button>
                                </div>
                            </ng-container>
                            <ng-template #vidNew>
                                <div class="relative !w-24 !h-24 rounded-lg hover:cursor-pointer">
                                    <video [src]="getMediaSrc(editFiles[0])" (click)="fileEdit.click()" controls class="w-full h-full object-cover rounded-lg"></video>
                                    <button
                                        (click)="removeFile('edit')"
                                        class="absolute top-[5px] right-[5px] !w-5 !h-5 bg-palette-gray-400 rounded-full flex items-center justify-center">
                                        <i class="sctr-icon-x-close text-sm"></i>
                                    </button>
                                </div>
                            </ng-template>
                        </ng-container>
                        
                        <!-- 2. OLD media -->
                        <ng-template #oldMedia>
                            <ng-container *ngIf="isImg(editMediasBackup[0]); else vidOld">
                            <div class="relative !w-24 !h-24 rounded-lg hover:cursor-pointer">
                                <img
                                    (click)="fileEdit.click()"
                                    [src]="getMediaSrc( editMediasBackup[0])"
                                    class="w-full h-full object-cover rounded-lg"
                                    (error)="replaceWithDefaultImage($event)"
                                />
                                <button
                                    (click)="editMediasBackup = []"
                                    class="absolute top-[5px] right-[5px] !w-5 !h-5 bg-palette-gray-400 rounded-full flex items-center justify-center">
                                    <i class="sctr-icon-x-close text-sm"></i>
                                </button>
                            </div>
                            </ng-container>
                            <ng-template #vidOld>
                            <div class="relative !w-24 !h-24 rounded-lg hover:cursor-pointer">
                                <video
                                    (click)="fileEdit.click()"
                                    [src]="getMediaSrc( editMediasBackup[0])"
                                    controls
                                    class="w-full h-full object-cover rounded-lg">
                                </video>
                                <button
                                    (click)="editMediasBackup = []"
                                    class="absolute top-[5px] right-[5px] !w-5 !h-5 bg-palette-gray-400 rounded-full flex items-center justify-center">
                                    <i class="sctr-icon-x-close text-sm"></i>
                                </button>
                            </div>
                            </ng-template>
                        </ng-template>
                    </div>
                </ng-container>
        
                <!-- READ MODE -->
                <ng-template #readMode>
                    <div class="bg-palette-gray-100 rounded-lg !p-2.5 !px-3">
                        <div class="flex justify-between items-center">
                            <div>
                                <span class="font-inter text-sm !font-medium text-palette-gray-900"> {{ c.created_by.full_name }} </span>
                                <span class="font-inter text-xs !font-normal text-palette-gray-500">• {{ formatCreatedAt(c.created_at) }}</span>
                            </div>
                            <!-- More -->
                                <div *ngIf="idAdmin === c.created_by.id">
                                    <button
                                        class="!p-1.5 rounded-lg hover:bg-palette-gray-200 !w-7 !h-7 flex items-center"
                                        (click)="toggleMore($event, i, morePanel)"
                                        [ngClass]="{ 'bg-palette-gray-200': activeRow === i }">
                                        <i class="sctr-icon-dots-horizontal"></i>
                                    </button>
                                    <p-overlayPanel #morePanel (onHide)="activeRow = -1" [dismissable]="true">
                                        <!-- MORE OPTIONS -->
                                        <div 
                                            class="more-action-flight-list flex flex-col"
                                        >
                                            <!-- Edit -->
                                            <ng-container>
                                                <div (click)="startEdit(c); morePanel.hide()" class="flex !gap-3 items-center !p-3 hover:bg-palette-gray-100 rounded-lg hover:cursor-pointer">
                                                    <i class="sctr-icon-edit-03 text-palette-gray-500"></i>
                                                    <button 
                                                        class="flex items-center !gap-3">
                                                        <p class="text-palette-gray-900 text-sm font-medium">{{ 'COMMON.EDIT' | translate }}</p>
                                                    </button>
                                                </div>
                                            </ng-container>
                                            <!-- Delete -->
                                            <ng-container>
                                                <div (click)="onShowConfirmDelete(c.id); morePanel.hide()" class="flex !gap-3 items-center !p-3 hover:bg-palette-gray-100 rounded-lg hover:cursor-pointer">
                                                    <i class="sctr-icon-trash-01 text-palette-red-600"></i>
                                                    <button 
                                                        class=" flex items-center !gap-3">
                                                        <p class="text-palette-red-600 text-sm font-medium">{{ 'COMMON.DELETE' | translate }}</p>
                                                    </button>
                                                </div>
                                            </ng-container>
                                        </div>
                                    </p-overlayPanel>
                                </div>
                        </div>
                        <div>
                            <p class="text-sm font-inter text-palette-gray-900 !font-normal whitespace-pre-wrap break-all"  [ngClass]="{ 'line-clamp-3': !isExpanded(c.id) }">{{ c.content }}</p>
                            <span
                                *ngIf="shouldShowToggle(c.content)"
                                class="font-inter text-xs !font-medium text-palette-blue-600 cursor-pointer select-none"
                                (click)="toggleExpand(c.id)"
                            >
                                {{ isExpanded(c.id) ? ('COMMON.SHOW_LESS' | translate) : ('COMMON.VIEW_MORE' | translate) }}
                            </span>
                        </div>
                    </div>
            
                    <!-- media display -->
                    <div *ngIf="c.medias?.length" class="mt-2">
                        <ng-container *ngIf="isImg(c.medias[0]); else vidShow">
                            <img
                                (click)="prviewMedia(i, c)"
                                class="w-24 h-24 object-cover rounded-lg hover:cursor-pointer"
                                [src]="getMediaSrc(c.medias[0])"
                                (error)="replaceWithDefaultImage($event)"
                            />
                        </ng-container>
                        <ng-template #vidShow>
                            <video
                                (click)="prviewMedia(i, c)"
                                [src]="getMediaSrc(c.medias[0])"
                                controls
                                class="!w-24 !h-24 rounded-lg hover:cursor-pointer">
                            </video>
                        </ng-template>
                    </div>
                </ng-template>
            </div>
        </div> 
        <!-- Loading spinner -->
        <div *ngIf="loadingMore" class="text-center py-2">
            <i class="pi pi-spin pi-spinner text-gray-500"></i>
        </div>
    </div>
</div>

<!-- Popup Confirm Delete -->
<ng-container *ngIf="isShowConfirmDeletePopup">
    <div class="fixed top-0 left-0 z-[9999] w-full h-full bg-black bg-opacity-75 flex justify-center items-center">
        <div class="!p-6 rounded-lg bg-white w-[384px]">
            <!-- HEADER -->
            <div class="flex justify-between items-center gap-4 !pb-6">
                <h2 class="text-palette-gray-900 text-lg font-semibold">
                    {{ 'COMMENTS.CONFIRM_DELETE_COMMENT' | translate }}</h2>
                <button *ngIf="!loadingDelete" (click)="onCloseConfirmDelete()" class="flex justify-center items-center !w-7 !h-7 rounded-full hover:bg-palette-gray-100">
                    <i class="sctr-icon-x-close text-xl leading-5"></i>
                </button>
            </div>
            <!-- BODY -->
            <p class="text-sm text-palette-gray-900">
                {{ 'COMMENTS.ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_COMMENT' | translate }}
            </p>
            <!-- FOOTER -->
            <div class="flex justify-end items-center gap-2 text-sm !pt-6">
                <button (click)="onCloseConfirmDelete()"
                    [disabled]="loadingDelete"
                    [ngClass]="{ 'hover:cursor-not-allowed opacity-50': loadingDelete }"
                    class="!h-11 !min-w-[88px] flex items-center justify-center border border-palette-gray-200 text-palette-gray-900 
                        font-semibold rounded-lg bg-white hover:!bg-palette-gray-200">
                    {{ 'COMMON.CANCEL' | translate }}
                </button>
                <button (click)="onConfirmDeleteComment()"
                    [disabled]="loadingDelete"
                    class="!h-11 !min-w-[102px] flex items-center justify-center text-white font-semibold rounded-lg"
                    [ngClass]="loadingDelete ? 'bg-palette-red-400' : 'bg-palette-red-600 hover:bg-palette-red-500'">
                    <ng-container *ngIf="!loadingDelete">
                        {{ 'COMMON.DELETE' | translate }}
                    </ng-container>
                    <ng-container *ngIf="loadingDelete">
                        <app-loading [style]="'!w-8 !h-8'"></app-loading>
                    </ng-container>
                </button>
            </div>
        </div>
    </div>
</ng-container>

<app-popup-preview
    *ngIf="isShowPopupPreviewMedia"
    [activeIndex]="0"
    [media]="comments[activePreview].medias"
    (onClose)="onClosePopupPreview()"
    [isServer]="isServerImg"
    [visible]="isShowPopupPreviewMedia">
</app-popup-preview>

<app-toast></app-toast>